import { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';

export default function StatCounter({ end, prefix = '', suffix = '', text, label }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const [display, setDisplay] = useState('0');

  useEffect(() => {
    if (!inView || text) return;
    const duration = 1700;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(end * eased).toString());
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, text]);

  return (
    <div ref={ref} className="text-center md:text-left" data-testid="stat-counter">
      <div className="font-display text-4xl font-extrabold tracking-tight text-navy dark:text-gold-light md:text-5xl">
        {text ?? `${prefix}${display}${suffix}`}
      </div>
      <div className="mt-2 text-sm leading-snug text-muted-c">{label}</div>
    </div>
  );
}
